/** Values a query string can carry; arrays are sent comma separated, like the gateway expects. */
export type QueryValue = string | number | boolean | string[] | undefined | null;
export type Query = Record<string, QueryValue>;

/** Builds `?a=1&b=x,y`, skipping empty values; returns an empty string for an empty query. */
export function buildQuery(query?: Query): string {
  if (!query) return '';
  const parts: string[] = [];
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null) continue;
    const flat = Array.isArray(value) ? value.join(',') : String(value);
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(flat)}`);
  }
  return parts.length > 0 ? `?${parts.join('&')}` : '';
}
